.tasksContainer {
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--default-bg);
  margin: 10px -8px 8px -8px;

  .count {
    display: flex;
    align-items: center;
    gap: 5px;
  }
}
